import Profile from "./Profile";
import * as motion from "motion/react-client"
import HelloText from "./HelloText";

const currentYear = new Date().getFullYear();

function App() {
  return (
    <div className="App mx-3">
        <div className="bg-white shadow-md shadow-dotted border border-black gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 max-w-[48rem] mx-auto mt-8 p-3">
            <div className="col-span-1 lg:col-span-5">
                <h1>
                    <span className="absolute text-6xl mt-4 ml-4 text-transparent">Hello</span>
                    <HelloText height={100} width={210} />
                </h1>
                <div className="ml-4">
                <motion.p className="text-3xl font-semibold text-balance" initial={{ opacity: 0}}
                          animate={{ opacity: 1}}
                          transition={{
                              duration: 0.5,
                              delay: 3,
                          }}>I'm Nicola, a swiss <span className="underline decoration-4">software developer</span> and <span className="underline decoration-4">student</span> currently pursuing my  <span className="text-gray-400">bachelor's degree</span> 👨🏻‍💻
                </motion.p>
                </div>
            </div>
            <div className="col-span-1 lg:col-span-2">
                <Profile/>
            </div>
            <hr className="w-full col-span-1 lg:col-span-7 border-dashed"></hr>
            <div className="col-span-1 md:col-span-2 lg:col-span-7">
                <div className="ml-4">

                    <p>This page is <span className="bg-hazard-stripe text-transparent clip-text font-bold drop-shadow-black"> under construction</span>.
                    </p>
                    <p>I’ll add more content as soon as I have the time.</p>
                </div>
            </div>
            <div className="col-span-1 md:col-span-2 lg:col-span-7">
                <div className="ml-4">
                    <p className="font-mono text-sm text-gray-800">©{currentYear}, Nicolà Widmer</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default App;
